import { render } from "./OrderTest.vue?vue&type=template&id=a1d33720&scoped=true"
import script from "./OrderTest.vue?vue&type=script&lang=js"
export * from "./OrderTest.vue?vue&type=script&lang=js"

import "./OrderTest.vue?vue&type=style&index=0&id=a1d33720&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1d33720"]])

export default __exports__